// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__HD_Fk","controls":"styles_controls__20zel","charLimit":"styles_charLimit__2nIa6","input":"styles_input__l-Zs5","send":"styles_send__3zbib"};